import { render } from "./AdminSpaces.vue?vue&type=template&id=c1c192d2&scoped=true"
import script from "./AdminSpaces.vue?vue&type=script&lang=js"
export * from "./AdminSpaces.vue?vue&type=script&lang=js"

import "./AdminSpaces.vue?vue&type=style&index=0&id=c1c192d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1c192d2"]])

export default __exports__